export const fallbackData = {
  BTC: {
    price: 72150,
    priceChange24h: 2.5,
    networkHashrate: 650000000, // TH/s (650 EH/s)
    blockReward: 3.125,   // After April 2024 halving
    blockTime: 600,       // 10 minutes
    difficulty: 71.6e12,
    feeReward: 1.18,      // Average transaction fees
    algorithm: 'SHA-256'
  },
  LTC: {
    price: 84.41,
    priceChange24h: 1.2,
    networkHashrate: 950000, // TH/s
    blockReward: 6.25,    // Current reward
    blockTime: 150,       // 2.5 minutes
    difficulty: 23.4e6,
    feeReward: 1.05,      // Lower transaction fees
    algorithm: 'Scrypt'
  },
  ETH: {
    price: 3975,
    priceChange24h: 3.1,
    networkHashrate: 1200000, // TH/s post-merge
    blockReward: 0.15,     // Base reward + average tips
    blockTime: 12,         // 12 seconds
    difficulty: 12.8e15,
    feeReward: 1.15,       // Post-merge MEV rewards
    algorithm: 'Ethash'
  },
  KDA: {
    price: 1.45,
    priceChange24h: 0.8,
    networkHashrate: 750000,  // TH/s
    blockReward: 0.7,      // Per chain
    blockTime: 30,         // 30 seconds
    chainCount: 20,
    difficulty: 8.9e9,
    feeReward: 1.01,
    algorithm: 'Blake2s'
  }
};